import React from 'react';
import FitnessProfileSectionCard from '../shared/FitnessProfileSectionCard';
import FitnessProfileReadingActions from '../shared/FitnessProfileReadingActions';
import FitnessProfileWeightLineChart from '../FitnessProfileWeightLineChart';

export default function FitnessProfileWeightTrackingSection({
	canLogReadings,
	chart,
	weightGoal,
	onManage,
	onLog
}) {
	return (
		<FitnessProfileSectionCard
			title="Weight Tracking"
			subtitle="lbs"
			headerAction={
				canLogReadings ? (
					<FitnessProfileReadingActions
						onEdit={onManage}
						onAdd={onLog}
						editAriaLabel="Manage weight readings"
						editTitle="Manage weight readings"
						addAriaLabel="Log weight reading"
						addTitle="Log weight"
					/>
				) : null
			}
		>
			<FitnessProfileWeightLineChart
				data={chart.points}
				trendLine={chart.trendLine}
				weightGoal={weightGoal}
			/>
		</FitnessProfileSectionCard>
	);
}
